import React from 'react';

export default ({ demande }) => {
    return (<>
        <p><b>Date Organisation: </b>{demande?.dateOrganisation ? new Date(demande.dateOrganisation).toLocaleDateString() : "/"}</p>
        <p><b>Adresse de Départ: </b>{demande.adresseDeDepart ? demande.adresseDeDepart : " / "}</p>
    </>);
}